export const testAttributes = {
    LINK_CONTAINER: 'link-container',
    LINK_GROUP: 'link-group',
    LINK_ITEM: 'link-item-'
}

export const compProps = [
    {
        "databaseId": 11,
        "label": "Terms of Use",
        "path": "/legal/terms-of-use",
        "parentId": null,
        "parentDatabaseId": 0,
        "submenu": {
            "nodes": []
        }
    },
    {
        "databaseId": 12,
        "label": "Our Privacy",
        "path": "/legal/privacy-policy",
        "parentId": null,
        "parentDatabaseId": 0,
        "submenu": {
            "nodes": []
        }
    },
    {
        "databaseId": 18,
        "label": "Artificial Intelligence Policy",
        "path": "/legal/ai-policy",
        "parentId": null,
        "parentDatabaseId": 0,
        "submenu": {
            "nodes": []
        }
    },
    {
        "databaseId": 13,
        "label": "State Privacy Notice",
        "path": "/legal/state-privacy",
        "parentId": null,
        "parentDatabaseId": 0,
        "submenu": {
            "nodes": []
        }
    },
    {
        "databaseId": 14,
        "label": "Licenses & Disclosures",
        "path": "/legal/disclosures-licenses",
        "parentId": null,
        "parentDatabaseId": 0,
        "submenu": {
            "nodes": []
        }
    },
    {
        "databaseId": 15,
        "label": "Ad Targeting Policy",
        "path": "/legal/ad-targeting",
        "parentId": null,
        "parentDatabaseId": 0,
        "submenu": {
            "nodes": []
        }
    },
    {
        "databaseId": 16,
        "label": "Unsubscribe",
        "path": "https://www.starleafsquare.com/o-nrpx-d41-18fc5e526fb936daac7301f127413de5",
        "parentId": null,
        "parentDatabaseId": 0,
        "submenu": {
            "nodes": []
        }
    },
    {
        "databaseId": 17,
        "label": "Do Not Sell My Personal Information",
        "path": "https://privacyportal-cdn.onetrust.com/dsarwebform/37cf9a71-5b40-4cf5-a30e-8beabeed8379/c3baaee8-0b37-4f2b-bf4c-76b0e035482e.html",
        "parentId": null,
        "parentDatabaseId": 0,
        "submenu": {
            "nodes": []
        }
    }
];